import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Alert,
  Box,
  CircularProgress,
  Container,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import Header from "../header_h/Header";
import Footer from "../footer/Footer";
import { getSubjectsByClass } from "../../api/subjects.js";

import "./class_page.css";

const ClassPage = ({ userName, userRoles }) => {
  const { id } = useParams();

  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;

    async function load() {
      setLoading(true);
      setError(null);

      try {
        const data = await getSubjectsByClass(id);
        if (alive) setSubjects(Array.isArray(data) ? data : []);
      } catch (e) {
        const status = e?.response?.status;
        const message =
          e?.response?.data?.message ||
          e?.response?.data ||
          e?.message ||
          "Помилка завантаження";

        if (alive) setError(status ? `${status}: ${message}` : String(message));
      } finally {
        if (alive) setLoading(false);
      }
    }

    load();
    return () => {
      alive = false;
    };
  }, [id]);

  return (
    <>
      <Header userName={userName} userRoles={userRoles} />

      <Container maxWidth="md" className="catalog-page">
        <Box className="catalog-page__heading">
          <Typography variant="h4" component="h1">
            Клас {id}
          </Typography>
          <Typography color="text.secondary">
            Оберіть предмет, щоб перейти до підручників і модулів.
          </Typography>
        </Box>

        <Paper className="catalog-panel" variant="outlined">
          {loading && (
            <Box className="catalog-state">
              <CircularProgress size={28} />
              <Typography>Завантаження...</Typography>
            </Box>
          )}
          {error && <Alert severity="error">{error}</Alert>}

          {!loading && !error && (
            <List disablePadding className="catalog-list">
              {subjects.map((subject) => (
                <ListItemButton
                  key={subject.id || `${subject.classId}-${subject.subjectSlug}`}
                  component={Link}
                  to={`/class/${id}/${subject.subjectSlug}`}
                  className="catalog-list__item"
                >
                  <ListItemText primary={subject.title} />
                  <ChevronRightRoundedIcon />
                </ListItemButton>
              ))}
              {subjects.length === 0 && (
                <Typography className="catalog-empty">Поки що немає предметів.</Typography>
              )}
            </List>
          )}
        </Paper>
      </Container>

      <Footer />
    </>
  );
};

export default ClassPage;
